import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { SideNavComponent } from '@bo-client/core/navigation/side-nav/side-nav.component';
import { AppNewsViewerService } from '@bo-client/shared/app-news/app-news-viewer.service';

@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss']
})
export class ShellComponent implements OnInit {
  @ViewChild('scrollContainer')
  scrollContainer: ElementRef;

  @ViewChild(SideNavComponent)
  sideNavComponent: SideNavComponent;

  public menuExpanded: boolean;

  constructor(private appNewsViewerService: AppNewsViewerService) {}

  ngOnInit(): void {
    // Neuigkeiten für Sachbearbeiter (docs/technical/components/app-news.md); läuft einmal je Nutzer.
    this.appNewsViewerService.checkOnStartup();
  }
  onMenuSizeChanged($event: any) {
    this.menuExpanded = $event;
  }

  mainOverlayClicked() {
    this.sideNavComponent.toggleMenu();
  }
}
